




















import Tags from '@/components/Collection/Tags.vue';
import iconDatas from '@/constant/iconDatas.ts';
import tagId from '@/lib/tagId.ts';
import { Message } from 'element-ui';
import {Component, Vue, Watch} from 'vue-property-decorator';

@Component({
  components: {Tags},
})
export default class CreateTag extends Vue {
  public iconDatas  = [] as CreatedTags[];
  public title = '';
  public id = 0;
  public selfTagsList: CreatedTags[] = JSON.parse(localStorage.getItem('selfTagsList') || '[]');
  public newTags: CreatedTags = {
    name: '',
    src: '',
    id: 0,
    type: 'creation',
  };

  public beforeMount() {
    this.$store.commit('fetchTags');
    this.iconDatas = this.$store.state.iconDatas;
    this.id = parseInt(this.$route.query.id as string, 10) || 0;
    if (this.id) {
      this.title = '修改标签';
      this.$store.commit('getCurrentTags', this.id);
      this.newTags = this.$store.state.currentTag;
    } else {
      this.title = '新建标签';
    }
  }
  public toBack() {
    this.$router.replace('/information');
  }
  public clearName() {
    this.newTags.name = '';
  }
  public save() {

    if (this.newTags.name) {

      // this.$store.commit('existName', this.newTags.name);
      // if (this.$store.state.existName) {
      //   this.$store.commit('iniExistName');
      //   return;
      // }
      if (this.newTags.name.length > 10) {
        return this.$message({
          message: '标签字数超过10字',
          type: 'warning',
          duration: 1000,
        });
      }
      if (this.id) {
        // 有id说明要修改标签属性
        this.$store.commit('updateTags', {id: this.id, newTags: this.newTags});

        return;
      } else if (!this.id) {
        // 链接没id就说明是创建标签

        this.newTags.id = tagId();
        this.$store.commit('createTags', this.newTags);

      }

    } else if (!this.newTags.name) {
      this.$message({
        message: '请填写标签名',
        type: 'warning',
        duration: 1000,
      });
    }
  }



}
